export const NAVIGATION_WIDTH = '240px';
